import React, { PropsWithChildren, useCallback, useContext, useMemo, useRef } from 'react';

import { CustomBottomSheetModalProvider } from '@/feature/alerts/components/CustomBottomSheetModalProvider';

import { PromoRemovedModal, PromoRemovedModalRef, PromoRemovedProps } from './PromoRemovedModal';

export type PromoRemoved = {
    showPromoRemovedModal: (props: PromoRemovedProps) => void;
};

const PromoRemovedContext = React.createContext<PromoRemoved | undefined>(undefined);

export const PromoRemovedModalProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const modalRef = useRef<PromoRemovedModalRef>(null);

    const showPromoRemovedModal = useCallback((props: PromoRemovedProps) => {
        modalRef.current?.show(props);
    }, []);

    const value: PromoRemoved = useMemo(
        () => ({
            showPromoRemovedModal,
        }),
        [showPromoRemovedModal]
    );

    return (
        <CustomBottomSheetModalProvider>
            <PromoRemovedContext.Provider value={value}>
                {children}
                <PromoRemovedModal ref={modalRef} />
            </PromoRemovedContext.Provider>
        </CustomBottomSheetModalProvider>
    );
};

export const usePromoRemoved = () => {
    const context = useContext(PromoRemovedContext);
    if (context === undefined) {
        throw new Error('usePromoRemoved must be used within a PromoRemovedModalProvider');
    }
    return context;
};
